/* purekickz newsletter pop-up (sections/pk-newsletter-popup.liquid). Kept as a separate, cached file
   instead of inline in every page (2026-10-20). No Liquid inside. */
(function () {
  if (customElements.get('pk-signup-popup')) return;
  var KEY = 'pk-popup-until';
  var DAY = 86400000;

  function blockedUntil() {
    try {
      return Number(localStorage.getItem(KEY)) || 0;
    } catch (_) {
      return 0;
    }
  }

  function blockFor(days) {
    try {
      localStorage.setItem(KEY, String(Date.now() + days * DAY));
    } catch (_) {}
  }

  class PkSignupPopup extends HTMLElement {
    connectedCallback() {
      this.days = Number(this.dataset.days) || 14;
      this.dialog = this.querySelector('dialog');

      // Back from a normal (non-fetch) form post: Shopify adds ?customer_posted=true on success.
      var pending = false;
      try {
        pending = sessionStorage.getItem('pkp-pending') === '1';
        sessionStorage.removeItem('pkp-pending');
      } catch (_) {}
      if (/[?&]customer_posted=true/.test(location.search)) {
        blockFor(365);
        if (pending) {
          this.open(false);
          this.showDone();
        }
        return;
      }
      // The post came back with an error (e.g. an invalid address): show the pop-up with the message.
      if (pending && this.querySelector('[data-pkp-server-error]')) {
        this.open(false);
        return;
      }

      if (this.hasAttribute('data-design-mode')) {
        document.addEventListener('shopify:section:select', (event) => {
          if (this.closest('.shopify-section') === event.target) this.open(true);
        });
        return;
      }
      if (blockedUntil() > Date.now()) return;

      this.start = Date.now();
      this.minMs = (Number(this.dataset.min) || 8) * 1000;
      var delayMs = (Number(this.dataset.delay) || 25) * 1000;
      var scrollShare = (Number(this.dataset.scroll) || 50) / 100;

      // Product pages (see sections/pk-newsletter-popup.liquid): only after 40 s on the page, never
      // from scrolling, and not at all for a visitor who already has something in the cart
      var productPage = this.hasAttribute('data-product-page');
      this.productPage = productPage;
      if (!productPage) this.timer = setTimeout(() => this.trigger(), delayMs);
      else if (!(Number(this.dataset.cartCount) > 0)) this.timer = setTimeout(() => this.trigger(), 40000);

      this.onScroll = () => {
        if (this.scrollQueued) return;
        this.scrollQueued = true;
        requestAnimationFrame(() => {
          this.scrollQueued = false;
          var room = document.documentElement.scrollHeight - window.innerHeight;
          if (room > 0 && window.scrollY / room >= scrollShare) this.trigger();
        });
      };
      if (!productPage) window.addEventListener('scroll', this.onScroll, { passive: true });

      if (window.matchMedia('(pointer: fine) and (min-width: 750px)').matches) {
        this.onLeave = (event) => {
          if (!event.relatedTarget && event.clientY <= 0) this.trigger();
        };
        document.addEventListener('mouseout', this.onLeave);
      }
    }

    disconnectedCallback() {
      this.stop();
    }

    stop() {
      clearTimeout(this.timer);
      if (this.onScroll) window.removeEventListener('scroll', this.onScroll);
      if (this.onLeave) document.removeEventListener('mouseout', this.onLeave);
    }

    trigger() {
      var wait = this.minMs - (Date.now() - this.start);
      if (wait > 0) {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => this.trigger(), wait);
        return;
      }
      // The timer ran out while the visitor was in another tab or app (Clarity 2f09d987, 2026-11-02:
      // the pop-up was the first thing they saw on coming back, they closed it and left). Wait until
      // the page is visible again, then give them 10 s with it before asking.
      if (document.hidden) {
        clearTimeout(this.timer);
        if (!this.waitingVisible) {
          this.waitingVisible = true;
          var onVisible = () => {
            if (document.hidden) return;
            document.removeEventListener('visibilitychange', onVisible);
            this.waitingVisible = false;
            clearTimeout(this.timer);
            this.timer = setTimeout(() => this.trigger(), 10000);
          };
          document.addEventListener('visibilitychange', onVisible);
        }
        return;
      }
      if (document.querySelector('dialog[open]')) {
        // Another dialog is open: do not stack. On a product page (size sheet, cart, alert) try again a
        // little later instead of giving up
        if (this.productPage) {
          clearTimeout(this.timer);
          this.timer = setTimeout(() => this.trigger(), 15000);
        }
        return;
      }
      if (!this.productPage) {
        this.stop();
        this.open(false);
        return;
      }
      // Product page: someone who added a pair in the meantime is buying, leave them alone
      this.stop();
      fetch('/cart.js', { credentials: 'same-origin' })
        .then((response) => (response.ok ? response.json() : null))
        .then((cart) => {
          if (cart && cart.item_count > 0) return;
          if (document.querySelector('dialog[open]')) return;
          this.open(false);
        })
        .catch(() => {});
    }

    open(preview) {
      if (!this.bound) {
        // The styles are added only now; the dialog is moved to <body> so no footer styles
        // (overflow, z-index, transforms) can clip or cover it. Moving keeps the same form element.
        var template = this.querySelector('template');
        var holder = document.createElement('div');
        holder.className = 'pkp-holder';
        holder.appendChild(template.content.cloneNode(true));
        holder.appendChild(this.dialog);
        document.body.appendChild(holder);
        this.form = this.dialog.querySelector('form');
        this.bind();
        this.bound = true;
      }
      if (this.dialog.open) return;
      var desktop = window.matchMedia('(min-width: 750px)').matches;
      if (desktop) {
        this.dialog.showModal();
      } else {
        this.dialog.show(); // phones: a sheet at the bottom, the page stays usable
        this.trackViewport();
      }
      this.preview = preview;
    }

    // Phones: when the on-screen keyboard opens (tapping the e-mail field), iOS Safari does not move
    // elements stuck to the bottom of the screen, so the keyboard would cover the field and the button.
    // The visible part of the page (visualViewport) is followed and the sheet is lifted to sit right
    // on top of the keyboard, and kept no taller than the space that is left.
    trackViewport() {
      var vv = window.visualViewport;
      if (!vv || this.onViewport) return;
      this.onViewport = () => {
        if (this.vvFrame) return;
        this.vvFrame = requestAnimationFrame(() => {
          this.vvFrame = 0;
          var covered = Math.max(0, window.innerHeight - vv.height - vv.offsetTop);
          this.dialog.style.bottom = covered + 'px';
          this.dialog.style.maxHeight = Math.max(200, Math.round(vv.height) - 8) + 'px';
        });
      };
      vv.addEventListener('resize', this.onViewport);
      vv.addEventListener('scroll', this.onViewport);
      this.onViewport();
    }

    untrackViewport() {
      var vv = window.visualViewport;
      if (!vv || !this.onViewport) return;
      vv.removeEventListener('resize', this.onViewport);
      vv.removeEventListener('scroll', this.onViewport);
      cancelAnimationFrame(this.vvFrame);
      this.vvFrame = 0;
      this.onViewport = null;
      this.dialog.style.bottom = '';
      this.dialog.style.maxHeight = '';
    }

    close() {
      if (this.dialog && this.dialog.open) this.dialog.close();
    }

    showDone() {
      this.done = true;
      this.dialog.querySelector('[data-pkp-step="form"]').hidden = true;
      this.dialog.querySelector('[data-pkp-step="done"]').hidden = false;
    }

    bind() {
      this.dialog.addEventListener('close', () => {
        this.untrackViewport();
        if (!this.preview && !this.done) blockFor(this.days);
      });
      this.dialog.addEventListener('click', (event) => {
        if (event.target === this.dialog || event.target.closest('[data-pkp-close]')) this.close();
      });
      this.dialog.addEventListener('keydown', (event) => {
        if (event.key === 'Escape') this.close();
      });

      var copy = this.dialog.querySelector('[data-pkp-copy]');
      if (copy) {
        copy.addEventListener('click', () => {
          var code = this.dialog.querySelector('[data-pkp-code]').textContent.trim();
          if (navigator.clipboard) navigator.clipboard.writeText(code).catch(() => {});
          copy.textContent = copy.dataset.copied;
        });
      }

      // Sending without a page reload (tested 2026-10-21: subscriber created, tags newsletter + popup).
      // Shopify's spam protection owns the submit: when the e-mail field gets focus it binds hCaptcha to
      // the form; on submit it stops the browser, adds its CAPTCHA token (h-captcha-response, form_key)
      // and then calls form.submit() itself. The submit event is therefore left alone, and only that
      // final form.submit() call is replaced: the form, token included, is sent in the background with
      // fetch, and Shopify's answer is read directly (?customer_posted=true = subscribed). If Shopify
      // answers with its visible "I am not a robot" page (rare), the form is sent once more the normal
      // way so the visitor can solve it, and the pop-up reopens with the code after the reload. If the
      // protection script is missing altogether, the browser simply sends the form the normal way.
      var nativeSubmit = HTMLFormElement.prototype.submit;
      this.form.submit = () => this.sendInBackground(nativeSubmit);

      var button = this.form.querySelector('button[type="submit"]');
      var error = this.form.querySelector('[data-pkp-error]');

      this.form.addEventListener('submit', () => {
        try {
          sessionStorage.setItem('pkp-pending', '1');
        } catch (_) {}
        error.hidden = true;
        button.disabled = true;
        clearTimeout(this.sendTimer);
        // Safety net: if nothing was sent within 20 s, let the visitor try again.
        this.sendTimer = setTimeout(() => this.showError(), 20000);
      });
    }

    sendInBackground(nativeSubmit) {
      clearTimeout(this.sendTimer);
      var form = this.form;
      fetch(form.action, {
        method: 'POST',
        body: new FormData(form),
        credentials: 'same-origin',
        headers: { Accept: 'text/html' },
      })
        .then((response) => {
          if (response.ok && /[?&]customer_posted=true/.test(response.url)) {
            try {
              sessionStorage.removeItem('pkp-pending');
            } catch (_) {}
            blockFor(365);
            form.querySelector('button[type="submit"]').disabled = false;
            this.showDone();
            return null;
          }
          if (/\/challenge/.test(response.url)) {
            nativeSubmit.call(form);
            return null;
          }
          return response.text();
        })
        .then((html) => {
          if (html === null) return;
          var doc = new DOMParser().parseFromString(html, 'text/html');
          var message = doc.querySelector('[data-pkp-server-error]');
          this.showError(message && message.textContent.trim());
        })
        .catch(() => this.showError());
    }

    showError(text) {
      clearTimeout(this.sendTimer);
      try {
        sessionStorage.removeItem('pkp-pending');
      } catch (_) {}
      var button = this.form.querySelector('button[type="submit"]');
      var error = this.form.querySelector('[data-pkp-error]');
      button.disabled = false;
      if (!error.dataset.defaultText) error.dataset.defaultText = error.textContent;
      error.textContent = text || error.dataset.defaultText;
      error.hidden = false;
    }
  }

  customElements.define('pk-signup-popup', PkSignupPopup);
})();
